import { Pagination } from 'antd';
import { paginationNavigationRenderer } from '../../../../utils/paginationNavigationrenderer';
import { StyledPagination } from './style';

interface PaginationProps {
  totalRecords: number;
  pageSize: number;
  currentPage: number;
  onChange: (page: number, itemsPerPage: number) => void;
}

const DefaultPagination = ({
  pageSize,
  currentPage,
  totalRecords,
  onChange,
}: PaginationProps) => {
  const DEFAULT_PAGE_SIZE = 20;

  return (
    <StyledPagination className={'pagination'}>
      <div className={'pagination-wrapper'}>
        <Pagination
          total={totalRecords}
          showSizeChanger={false}
          current={currentPage}
          defaultPageSize={DEFAULT_PAGE_SIZE}
          pageSize={pageSize}
          onChange={onChange}
          itemRender={paginationNavigationRenderer}
        />
      </div>
    </StyledPagination>
  );
};

export default DefaultPagination;
